import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2022 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbButton } from "abreact/misc/AbButton";
import { AbIcon } from "abreact/misc/AbIcon";
import { AbLink } from "abreact/misc/AbLink";
import * as React from "react";
export function AbDecorator(props) {
  const className = ReactUtils.classNamesString([props.className, "ab-decorator", props.onClick && "ab-no-border-button"]);
  if (props.linkProps) {
    const {
      linkProps,
      ...decoratorProps
    } = props;
    linkProps.href = linkProps.href ?? "";
    return /*#__PURE__*/React.createElement(AbLink, _extends({}, linkProps, decoratorProps, {
      className: className
    }));
  } else if (props.onClick) {
    return /*#__PURE__*/React.createElement(AbButton, _extends({}, props, {
      className: className
    }));
  } else {
    return /*#__PURE__*/React.createElement(AbIcon, _extends({}, props, {
      className: className,
      image: props.icon
    }));
  }
}
//# sourceMappingURL=AbDecorator.js.map
